import React, { FC, useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import Select from 'react-select';
import { fetchData, toasterrormsg, toastsuccessmsg } from '../../../reusable';
import { ToastContainer } from 'react-toastify';
import { AddCarRentalHeader } from './AddCarRentalHeader';
import moment from 'moment';
import { Calendar, Views, momentLocalizer, SlotInfo, CalendarProps } from 'react-big-calendar';
import PriceInput from '../PriceInput';
import { Tr } from '../../../_metronic/i18n/Tr';

const AddCarRentalAvailability: FC = () => {

  const t = Tr()
  const navigate = useNavigate()
  const categoryId = sessionStorage.getItem('categoryId');
  useEffect(() => {
    if (categoryId != '7') {
      navigate('../dashboard/');
    }
  }, [categoryId])
  const location = useLocation();
  const editCarrentalId = (location.state as any)?.carrentalId || '';

  var vendorId = "";
  const vendorData = sessionStorage.getItem("vendor");
  if (vendorData) {
    var vendor = JSON.parse(vendorData);
    vendorId = vendor.vendorId;

  } else {
    console.log("No vendor data found");
  }
  const [loading, setLoading] = useState(false)
  const [disable, setDisable] = useState(false);
  const [spaceRenatalDetails, setSpacerentalDetails] = useState([]);
  const availableTypeList = [
    { label: t('Available'), value: 'available' },
    { label: t('Unavailable'), value: 'unavailable' },
  ];
  const [availableTypeSelectedOptions, setAvailableTypeSelectedOptions] = useState<any>();
  // available type list state end
  const [startAvailableDate, setStartAvailableDate] = useState("");
  const [endAvailableDate, setEndAvailableDate] = useState("");

  // set error state
  const [error, setError] = useState([{
    isAllow: '',
    availableDate: '',
  }])

  // remove validation function
  const removeError = (err: any) => {
    var tmp = [...error] as any;
    tmp[0][err] = "";
    setError(tmp);
  }

  //     // ------------------- for schedule calander -------------------------
  const localizer = momentLocalizer(moment);

  interface CustomEvent {
    start: Date;
    end: Date;
    title: string;
    type: 'available' | 'unavailable';
  }
  const [events, setEvents] = useState<CustomEvent[]>([]);

  const [unAvailableEvents, setUnAvailableEvents] = useState<CustomEvent[]>([]);

  // Function to generate default events from today to one year ahead, ensuring UTC time zone
  const generateDefaultEvents = (unavailableEvents: CustomEvent[]) => {
    const defaultEvents: CustomEvent[] = [];

    // Force UTC start and end
    const startDate = moment.utc().startOf('day'); // Start at UTC midnight
    const endDate = moment.utc().add(2, 'year').endOf('day'); // End at UTC midnight of 2 years later

    // Iterate through days, setting each event to UTC midnight
    for (let date = startDate.clone(); date.isSameOrBefore(endDate); date.add(1, 'day')) {
      const eventDate = date.clone().toDate(); // Convert to JS Date in UTC

      // Check for existing unavailable events and create the appropriate event
      if (unavailableEvents.some(event => moment.utc(event.start).isSame(date, 'day'))) {
        defaultEvents.push({
          start: eventDate,
          end: eventDate,
          title: t('Unavailable'),
          type: 'unavailable'
        });
      } else {
        defaultEvents.push({
          start: eventDate,
          end: eventDate,
          title: t('Available'),
          type: 'available'
        });
      }
    }
    return defaultEvents;
  };

  // Use effect to synchronize unavailable events with the events state
  useEffect(() => {
    const updatedEvents = generateDefaultEvents(unAvailableEvents);
    setEvents(updatedEvents);
  }, [unAvailableEvents, t('Available')]);

  const handleSelectSlot = (slotInfo: SlotInfo) => {
    if (!availableTypeSelectedOptions) {
      toasterrormsg(t('Please Select Availability Type (available/unavailable).'));
      return;
    }

    const selectedDates: Date[] = [];

    // Convert both start and end to UTC with 12 AM time
    const startOfRange = moment.utc(slotInfo.start).startOf('day').add(1, 'days'); // Start of day in UTC
    const endOfRange = moment.utc(slotInfo.end).startOf('day'); // End of day in UTC

    // Loop through dates and select them in UTC
    for (let date = startOfRange.clone(); date.isSameOrBefore(endOfRange); date.add(1, 'day')) {
      selectedDates.push(date.toDate());
    }

    updateEvents(selectedDates);
  };

  const updateEvents = (selectedDates: Date[]) => {
    if (!availableTypeSelectedOptions) {
      toasterrormsg(t("Please Select Availability Types"));
      return;
    }

    const newEvents: CustomEvent[] = [];
    const eventsToRemove: CustomEvent[] = [];

    selectedDates.forEach(selectedDate => {
      const selectedMoment = moment.utc(selectedDate).startOf('day'); // Set to UTC midnight
      const existingEventIndex = events.findIndex(event => moment.utc(event.start).isSame(selectedMoment, 'day'));

      if (existingEventIndex !== -1) {
        eventsToRemove.push(events[existingEventIndex]);
      }

      const newEvent: CustomEvent = {
        start: selectedMoment.toDate(),
        end: selectedMoment.toDate(),
        title: availableTypeSelectedOptions.value!.charAt(0).toUpperCase() + availableTypeSelectedOptions.value!.slice(1),
        type: availableTypeSelectedOptions.value!
      };
      newEvents.push(newEvent);
    });

    const updatedEvents = events.filter(existingEvent =>
      !eventsToRemove.some(removeEvent => moment.utc(existingEvent.start).isSame(moment.utc(removeEvent.start), 'day'))
    );

    setEvents([...updatedEvents, ...newEvents]);

    // Update unavailable events
    if (availableTypeSelectedOptions.value === 'unavailable') {
      const newUnavailableEvents = newEvents.filter(event => event.type === 'unavailable');
      setUnAvailableEvents([...unAvailableEvents, ...newUnavailableEvents]);
    } else {
      const remainingUnavailableEvents = unAvailableEvents.filter(event =>
        !newEvents.some(ne => moment.utc(ne.start).isSame(moment.utc(event.start), 'day'))
      );
      setUnAvailableEvents(remainingUnavailableEvents);
    }
  };

  // Apply available dates with UTC time zone
  const ApplyAvailableDates = () => {
    if (!startAvailableDate || !endAvailableDate) {
      toasterrormsg(t('Please Select Both Start And End Dates.'));
      return;
    }

    const startDate = moment.utc(startAvailableDate).startOf('day'); // Convert start date to UTC midnight
    const endDate = moment.utc(endAvailableDate).startOf('day'); // Convert end date to UTC midnight
    const today = moment.utc().startOf('day'); // Current date in UTC

    if (startDate.isBefore(today) || endDate.isBefore(today)) {
      toasterrormsg(t('Please Select Only Current Or Future Dates.'));
      return;
    }

    const selectedDates: Date[] = [];

    // Loop through and convert each date to UTC
    for (let date = startDate.clone(); date.isSameOrBefore(endDate); date.add(1, 'day')) {
      selectedDates.push(date.toDate());
    }

    updateEvents(selectedDates);
  };

  // Clear available dates with UTC time zone
  const clearAvailableDates = () => {
    if (!startAvailableDate || !endAvailableDate) {
      toasterrormsg(t('Please Select Both Start And End Dates.'));
      return;
    }

    const startDate = moment.utc(startAvailableDate).startOf('day'); // Convert start date to UTC midnight
    const endDate = moment.utc(endAvailableDate).startOf('day'); // Convert end date to UTC midnight
    const today = moment.utc().startOf('day'); // Current date in UTC

    if (startDate.isBefore(today) || endDate.isBefore(today)) {
      toasterrormsg(t('Please Select Only Current Or Future Dates.'));
      return;
    }

    const selectedDates: Date[] = [];

    // Loop through and convert each date to UTC
    for (let date = startDate.clone(); date.isSameOrBefore(endDate); date.add(1, 'day')) {
      selectedDates.push(date.toDate());
    }

    const updatedEvents: CustomEvent[] = events.map(event => {
      const eventDate = moment.utc(event.start).startOf('day'); // Convert event date to UTC
      if (event.type === 'unavailable' && selectedDates.some(date => moment.utc(date).isSame(eventDate, 'day'))) {
        return {
          ...event,
          title: t('Available'),
          type: 'available'
        };
      }
      return event;
    });

    setEvents(updatedEvents);

    // Remove the corresponding events from unAvailableEvents
    const updatedUnavailableEvents = unAvailableEvents.filter(event => {
      const eventDate = moment.utc(event.start).startOf('day'); // Convert event date to UTC
      return !selectedDates.some(date => moment.utc(date).isSame(eventDate, 'day'));
    });

    setUnAvailableEvents(updatedUnavailableEvents);
  };


  const handleRemoveEvent = (event: CustomEvent) => {
    const updatedEvents = events.filter(existingEvent =>
      !(
        existingEvent.start === event.start &&
        existingEvent.end === event.end &&
        existingEvent.title === event.title &&
        existingEvent.type === event.type
      )
    );
    setEvents(updatedEvents);

    // Remove from unavailable events if applicable
    if (event.type === 'unavailable') {
      const updatedUnavailableEvents = unAvailableEvents.filter(unavailableEvent =>
        !(
          unavailableEvent.start === event.start &&
          unavailableEvent.end === event.end &&
          unavailableEvent.title === event.title &&
          unavailableEvent.type === event.type
        )
      );
      setUnAvailableEvents(updatedUnavailableEvents);
    }
  };

  const eventStyleGetter: CalendarProps<CustomEvent>['eventPropGetter'] = (event, start, end, isSelected) => {
    const backgroundColor = event.type === 'available' ? 'green' : 'red';
    const style = {
      backgroundColor,
      borderRadius: '0px',
      opacity: 0.8,
      color: 'white',
      border: '0px',
      display: 'block'
    };
    return {
      style
    };
  };
  // space Details api call
  const carRentalDetailsApiCall = async () => {

    var param: any = {
      carrentalId: String(editCarrentalId),
    }
    var response: any = await fetchData("public/carRentalDetail", param)

    if (response.status == "200") {
      setSpacerentalDetails(response.data);
      var data = response.data[0];
      if (data.availableDate.length != 0) {
        setUnAvailableEvents(data['availableDate'])
      }
    }
    else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    if (editCarrentalId != "") {
      carRentalDetailsApiCall();
    }
  }, [])
  // add space api call
  const addCarRentalAvailabilityApi = async () => {
    // if (validate()) {
    setDisable(true)
    setLoading(true);
    let param: any = {
      carrentalId: String(editCarrentalId),
      availableDate: JSON.stringify(unAvailableEvents)
    }

    var res = await fetchData("public/addavailability", param)
    if (res.status == "200") {
      toastsuccessmsg(t("Car Rental Availability Added Successfully!"))
      const state = {
        carrentalId: editCarrentalId
      }
      setTimeout(() => {
        navigate("../addcarrentalpickupordropoffinfo/", { state });
        setDisable(false)
        setLoading(false);
      }, 1500);
    }
    else {
      toasterrormsg(res.message)
      setDisable(false)
      setLoading(false);
    }
    // }

  }

  useEffect(() => {
    if (editCarrentalId != "") {
      carRentalDetailsApiCall();
    }
  }, [])
  return (
    <>
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>{editCarrentalId != "" ? t('Edit Car Rental') : t('Add Car Rental')}</PageTitle>
      <AddCarRentalHeader carrentalId={editCarrentalId} />
      <div className="d-flex flex-column flex-column-fluid">
        {/* <!--begin::Content--> */}
        <div id="kt_app_content" className="app-content flex-column-fluid">
          {/* <!--begin::Form--> */}
          <div className="form d-flex flex-column flex-lg-row">
            {/* <!--begin::Main column--> */}
            <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
              {/* <!--begin::Tab content--> */}
              <div className="tab-content">
                {/* <!--begin::Tab pane--> */}
                <div className="tab-pane fade show active" id="kt_ecommerce_add_product_general" role="tab-panel">
                  <div className="d-flex flex-column">
                    {/* <!--begin::General options--> */}
                    <div className="card card-flush py-4">
                      {/* <!--begin::Card header--> */}
                      {/* <!--begin::Card header--> */}
                      <div className="card-header d-flex">
                        {/* <!--begin::Card title--> */}
                        <div className="card-title">
                          <h2>{t('Car Rental Availability')}</h2>
                        </div>
                        {/* <!--end::Card title--> */}
                        <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                          {
                            spaceRenatalDetails.length != 0 ? (
                              <>
                                {
                                  spaceRenatalDetails.map((completedSteps: any, index: any) => {
                                    var percentage = 0;
                                    if (completedSteps['completedSteps']['basicInfo']) {
                                      percentage = 10;
                                    }
                                    if (completedSteps['completedSteps']['location']) {
                                      percentage = 20;
                                    }
                                    if (completedSteps['completedSteps']['carRentalInfo']) {
                                      percentage = 40;
                                    }
                                    if (completedSteps['completedSteps']['photos']) {
                                      percentage = 50;
                                    }
                                    if (completedSteps['completedSteps']['insurance']) {
                                      percentage = 60;
                                    }
                                    if (completedSteps['completedSteps']['documentsRequired']) {
                                      percentage = 70;
                                    }
                                    if (completedSteps['completedSteps']['availability']) {
                                      percentage = 70;
                                    }
                                    if (completedSteps['completedSteps']['pickupDropoffInfo']) {
                                      percentage = 80;
                                    }
                                    if (completedSteps['completedSteps']['policies']) {
                                      percentage = 90;
                                    }
                                    if (completedSteps['completedSteps']['financeAndLegal']) {
                                      percentage = 100;
                                    }
                                    return (
                                      <React.Fragment key={index}>
                                        <div className='d-flex justify-content-between w-100 mt-auto'>
                                          <span className='fw-bold fs-6'>{t('Completion')}</span>
                                          <span className='fw-bolder fs-6'>{percentage}%</span>
                                        </div>
                                        <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                          <div
                                            className='bg-success rounded h-5px'
                                            role='progressbar'
                                            style={{ width: `${percentage}%` }}
                                          ></div>
                                        </div>
                                      </React.Fragment>
                                    )
                                  })
                                }
                              </>
                            ) : (
                              <>
                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                  <span className='fw-bold fs-6'>{t('Completion')}</span>
                                  <span className='fw-bolder fs-6'>0%</span>
                                </div>
                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                  <div
                                    className='bg-success rounded h-5px'
                                    role='progressbar'
                                    style={{ width: '0%' }}
                                  ></div>
                                </div>
                              </>
                            )
                          }
                        </div>
                      </div>
                      {/* <!--end::Card header--> */}
                      <div className="card-body pt-0">
                        <div className="row mt-5">
                          <div className="col-lg-12">
                            <label className="fs-2 fw-bolder form-label">{t('Available Dates')}</label>
                          </div>
                          <div className="col-lg-12 my-3">
                            <span className='fw-bolder fs-5 form-label'>{t('*Note:')}<span className="fs-7 form-label" style={{ fontStyle: 'italic' }}> {t('First select availability types, then you can set availability from date range of above start date and end date and click on apply button. Or you can directly click on calender date box for single date selection.')}</span></span>
                          </div>
                          <div className="col-lg-4 my-3">
                            <label className="fs-5 form-label">{t('Availability Types')}</label>
                            <Select
                              name='availableType[]'
                              id='availableTypeList'
                              placeholder={t('Select Availability Types')}
                              isSearchable={true}
                              options={availableTypeList}
                              value={availableTypeSelectedOptions}
                              onChange={(e: any) => { setAvailableTypeSelectedOptions(e); }}
                            />
                          </div>
                          <div className="col-lg-8 my-3">
                            <div className="row">
                              <div className="col-lg">
                                <label className="fs-5 form-label">{t('Start Date')}</label>
                                <input type="date" name="startAvailableDate" className="form-control mb-2" value={startAvailableDate} onChange={(e) => { setStartAvailableDate(e.target.value); removeError("startAvailableDate"); }} />
                              </div>
                              <div className='col-lg'>
                                <label className="fs-5 form-label">{t('End Date')}</label>
                                <input type="date" name="endAvailableDate" className="form-control mb-2" value={endAvailableDate} onChange={(e) => { setEndAvailableDate(e.target.value); removeError("endAvailableDate"); }} />
                              </div>
                              <div className="col-lg d-flex align-items-end">
                                <button className='btn btn-primary mb-2 mx-1' onClick={ApplyAvailableDates}>{t('Apply')}</button>
                                <button className='btn btn-danger mb-2 mx-1' onClick={clearAvailableDates}>{t('Clear')}</button>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-12 my-5">
                            <Calendar
                              localizer={localizer}
                              events={events}
                              startAccessor="start"
                              endAccessor="end"
                              selectable
                              onSelectSlot={handleSelectSlot}
                              style={{ height: 500 }}
                              views={[Views.MONTH]}
                              eventPropGetter={eventStyleGetter}
                              onSelectEvent={(event: CustomEvent) => handleRemoveEvent(event)}
                            />
                          </div>
                          <div className='text-danger fw-bold'>{error[0].availableDate}</div>
                        </div>
                      </div>
                    </div>
                    {/* <!--end::Pricing--> */}
                  </div>
                </div>
                {/* <!--end::Tab pane--> */}
              </div>
              {/* <!--end::Tab content--> */}
              <div className="d-flex justify-content-end">
                {/* <!--begin::Button--> */}
                <Link to="../viewspacerentals/" id="kt_ecommerce_add_product_cancel" className="btn btn-light me-5">{t('Cancel')}</Link>
                {/* <!--end::Button--> */}
                <button type="submit" disabled={disable} className="btn btn-primary" onClick={addCarRentalAvailabilityApi}>
                  <span className="indicator-label">{t('Next')}</span>
                  {loading && (
                    <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                  )}
                </button>
                {/* <!--end::Button--> */}
              </div>
            </div>
            {/* <!--end::Main column--> */}
          </div>
          {/* <!--end::Form--> */}
        </div>
        {/* <!--end::Content--> */}
      </div>
    </>
  )
}

export { AddCarRentalAvailability }
